import {createApi} from "@reduxjs/toolkit/query/react"
import {IBasicResponse} from "../../types/api"
import baseQuery from "../../utils/apiIIKOConfig"
import {
    StoryByIdParams,
    StoryCreateParams,
    StoryCreateResponse,
    StoryDetailsResponse,
    StoryListParams,
    StoryListResponse,
    StoryUpdateImageListParams,
    StoryUpdateImagePositionParams,
    StoryUpdateParams,
    StoryUpdatePositionParams,
    StoryUpdatePositionResponse
} from "./StoryApiTypes"

export const storyApi = createApi({
    reducerPath: "storyApi",
    baseQuery,
    tagTypes: ["stories", "story"],
    endpoints: (build) => ({
        getStories: build.query<StoryListResponse, StoryListParams>({
            query: (body) => ({
                url: "/v1/stories/list",
                method: "POST",
                body
            }),
            providesTags: ["stories"]
        }),
        getStoryById: build.query<StoryDetailsResponse, StoryByIdParams>({
            query: ({id}) => ({
                url: `/v1/stories/${id}`,
                method: "GET",
            }),
            providesTags: (_result, _error, params) => [{type: "story", id: params.id}]
        }),
        createStory: build.mutation<IBasicResponse<StoryCreateResponse>, StoryCreateParams>({
            query: (body) => ({
                url: "/v1/stories",
                method: "POST",
                body
            }),
            invalidatesTags: ["stories"]
        }),
        updateStory: build.mutation<IBasicResponse<void>, StoryUpdateParams>({
            query: ({id, ...body}) => ({
                url: `/v1/stories/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: (_result, _error, params) => ["stories", {type: "story", id: params.id}]
        }),
        updateStoryImageList: build.mutation<IBasicResponse<void>, StoryUpdateImageListParams>({
            query: ({id, story_image_list}) => ({
                url: `/v1/stories/${id}/images`,
                method: "PUT",
                body: {story_image_list}
            }),
            invalidatesTags: (_result, _error, params) => ["stories", {type: "story", id: params.id}]
        }),
        updateStoryPosition: build.mutation<IBasicResponse<StoryUpdatePositionResponse>, StoryUpdatePositionParams>({
            query: ({id, position}) => ({
                url: `/v1/stories/${id}/positions`,
                method: "PATCH",
                body: {position}
            }),
            invalidatesTags: ["stories"]
        }),
        updateStoryImagePosition: build.mutation<IBasicResponse<StoryUpdatePositionResponse>, StoryUpdateImagePositionParams>({
            query: ({storyId, id, position}) => ({
                url: `/v1/stories/${storyId}/images/${id}/positions`,
                method: "PATCH",
                body: {position}
            }),
            invalidatesTags: (_result, _error, params) => ["stories", {type: "story", id: params.storyId}]
        })
    })
})

export const {
    useGetStoriesQuery,
    useLazyGetStoryByIdQuery,
    useCreateStoryMutation,
    useUpdateStoryMutation,
    useUpdateStoryImageListMutation,
    useUpdateStoryPositionMutation,
    useUpdateStoryImagePositionMutation
} = storyApi
